import React, { lazy } from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy-loaded components
const EventCategoryList = lazy(() => import("@/modules/eventRegistration/features/EventCategoryManagement/components/EventCategoryList/EventCategoryList"));
const EventList = lazy(() => import("@/modules/eventRegistration/features/EventManagement/components/EventList/EventList"));
const CreateEvent = lazy(() => import("@/modules/eventRegistration/features/EventManagement/components/CreateEvent/CreateEvent"));
const EditEvent = lazy(() => import("@/modules/eventRegistration/features/EventManagement/components/EditEvent/EditEvent"));
const EventSessionList = lazy(() => import("@/modules/eventRegistration/features/EventSessionManagement/components/EventSessionList/EventSessionList"));
const EventDirectory = lazy(() => import("@/modules/eventRegistration/features/EventDirectory/components/EventDirectory/EventDirectory"));
const EventDetails = lazy(() => import("@/modules/eventRegistration/features/EventDirectory/components/EventDetails/EventDetails"));
const SelectAttendees = lazy(() => import("@/modules/eventRegistration/features/EventRegistration/components/SelectAttendees/SelectAttendees"));
const Checkout = lazy(() => import("@/modules/eventRegistration/features/EventRegistration/components/Checkout/Checkout"));
const EventRegistrationEntry = lazy(() => import("@/modules/eventRegistration/features/EventRegistration/components/EventRegistrationEntry/EventRegistrationEntry"));
const Confirmation = lazy(() => import("@/modules/eventRegistration/features/EventRegistration/components/Confirmation/Confirmation"));
const EventInstructorList = lazy(() => import("@/modules/eventRegistration/features/EventInstructorManagement/components/EventInstructorList/EventInstructorList"));
const VoucherList = lazy(() => import("@/modules/eventRegistration/features/EventVoucherManagement/components/VoucherList/VoucherList"));
const CreateVoucher = lazy(() => import("@/modules/eventRegistration/features/EventVoucherManagement/components/CreateVoucher/CreateVoucher"));
const VenueList = lazy(() => import("@/modules/eventRegistration/features/EventVenueManagement/components/VenueList/VenueList"));
const CreateVenue = lazy(() => import("@/modules/eventRegistration/features/EventVenueManagement/components/CreateVenue/CreateVenue"));
const EditVenue = lazy(() => import("@/modules/eventRegistration/features/EventVenueManagement/components/EditVenue/EditVenue"));
const DiscountList = lazy(() => import("@/modules/eventRegistration/features/EventDiscountManagement/components/DiscountList/DiscountList"));
const CreateDiscount = lazy(() => import("@/modules/eventRegistration/features/EventDiscountManagement/components/CreateDiscount/CreateDiscount"));
const EditDiscount = lazy(() => import("@/modules/eventRegistration/features/EventDiscountManagement/components/EditDiscount/EditDiscount"));
const EditVoucher = lazy(() => import("@/modules/eventRegistration/features/EventVoucherManagement/components/UpdateVoucher/UpdateVoucher"));
const Waitlist = lazy(() => import("@/modules/eventRegistration/features/EventWaitlist/components/Waitlist/Waitlist"));

// Create stable component reference
const EventRegistrationMainLayout = () => (
  <MainLayout section="event-registration" />
);

const EventRegistrationRoutes = (
  <Route
    element={<AuthenticationGuard component={EventRegistrationMainLayout} />}
    path="/event-registration"
  >
    {/* Public Event Directory */}
    <Route element={<EventDirectory />} path="events" />
    <Route element={<EventDetails />} path="events/:uuid" />

    {/* Event Registration Flow */}
    <Route
      element={<EventRegistrationEntry />}
      path="events/register/:eventSessionUuid/entry"
    />
    <Route
      element={<SelectAttendees />}
      path="events/register/:eventCheckoutSessionUuid/attendees"
    />
    <Route
      element={<Checkout />}
      path="events/register/:eventCheckoutSessionUuid/checkout"
    />
    <Route
      element={<Confirmation />}
      path="events/register/:eventCheckoutSessionUuid/confirmation"
    />
  </Route>
);

export default EventRegistrationRoutes;
